import { FunctionComponent, ReactNode, useEffect, useState } from 'react';
import { AssetTypeModel } from '../types/AssetTypeModel';
import { assetTypeService } from '../api/asset-types/asset-type.service';
import { AssetTypeReadDTO } from '../api/asset-types/asset-type.contracts';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText, SelectChangeEvent, IconButton } from '@mui/material';
import { Clear } from '@mui/icons-material';
import { useTranslation } from '@/lib';

interface AssetTypeSelectProps {
  selectedAssetTypeId?: number;
  onChange: (selectedAssetType?: AssetTypeModel) => void;
  helperText?: string;
  label?: string;
}

const AssetTypeSelect: FunctionComponent<AssetTypeSelectProps> = ({ selectedAssetTypeId, onChange, helperText, label }) => {
  const { t } = useTranslation();

  if (!label) {
    label = t('asset_type');
  }

  const [assetTypes, setAssetTypes] = useState<AssetTypeModel[]>([]);

  async function getAllAssetTypes() {
    const response = await assetTypeService.getNames();
    if (response.isSuccess) {
      // The names endpoint only returns id, name and code; wrap them in a model to keep the onChange contract.
      setAssetTypes(response.payload.map((name) => AssetTypeModel.fromDTO(name as AssetTypeReadDTO)));
    }
  }
  useEffect(() => {
    getAllAssetTypes();
  }, []);

  function onAssetTypeChanged(event: SelectChangeEvent<number>, child: ReactNode) {
    const selectedAssetType = assetTypes.find((at) => at.id === event.target.value);

    onChange(selectedAssetType);
  }
  return (
    <FormControl className="w-full">
      {label && <InputLabel>{label}</InputLabel>}
      <Select
        value={selectedAssetTypeId && assetTypes.length > 0 ? selectedAssetTypeId : ''}
        label={label}
        onChange={onAssetTypeChanged}
        endAdornment={
          (selectedAssetTypeId ?? 0) > 0 && (
            <IconButton className=" absolute right-3  mr-6 flex " color="inherit" onClick={() => onChange(undefined)} aria-label="close">
              <Clear />
            </IconButton>
          )
        }
      >
        {assetTypes.map((assetType) => {
          return (
            <MenuItem key={assetType.id} value={assetType.id}>
              {assetType.name}
            </MenuItem>
          );
        })}
      </Select>
      {helperText && <FormHelperText>{helperText} </FormHelperText>}
    </FormControl>
  );
};

export default AssetTypeSelect;
